<template>
  <div>
    <label>{{label}} <span v-if="required" class="text-danger">*</span> {{label_extra}}</label>
    <draggable
      v-model="images"
      class="mb-3"
      ghost-class="ghost"
      @change="sortOrderImages"
    >
      <transition-group class="row">
        <div v-for="image in images" :key="image" class="col-6 col-md-4 mb-3 draggable">
            <img :src="image" class="w-100" />
            <div
              class="btn btn-danger btn-sm w-100 rounded-0"
              @click="deleteImage(image)"
            >Delete</div>
        </div>
      </transition-group>
    </draggable>
    <input
        class="d-none"
        :ref="'input_file_'+this.dataFieldName"
        type="file"
        @change="uploadImage"
        :multiple="!max_images || max_images > 1"
    />
    <!-- ref="file" -->
    <!-- @click="$refs.file.click()" -->
    <!-- @click="$refs['input_file_'+this.fieldName].click()" -->
    <div class="btn btn-secondary btn-sm mb-2"
    @click="openFileInput"
    >
      <i class="fa fa-upload"></i> Upload images
    </div>
    <div class="font-italic small mb-3">
        *Max {{max_images}} images<br/>
        *Optimal size: {{width}}x{{height}} pixels<br/>
        <!-- *Max file size: {{config.product_image_max_size+'Mb'}}<br/> -->
        *Allowed file extensions: .jpg, .png
    </div>
  </div>
</template>

<script>
import draggable from "vuedraggable";
export default {
  props: ['dataFieldName'],
  data() {
    return {
        // fieldName: this.dataFieldName,
        config: config,
        settings: settings,
        files: [],
        images: window[this.dataFieldName]['images'],
        model_id: window[this.dataFieldName]['model_id'],
        model: window[this.dataFieldName]['model'],
        required: window[this.dataFieldName]['required'],
        label: window[this.dataFieldName]['label'],
        column: window[this.dataFieldName]['column'],
        label_extra: window[this.dataFieldName]['label_extra'],
        max_images: window[this.dataFieldName]['max_images'] ? window[this.dataFieldName]['max_images'] : config.images_max,
        width: window[this.dataFieldName]['width'] ? window[this.dataFieldName]['width'] : settings.product_image_width,
        height: window[this.dataFieldName]['height'] ? window[this.dataFieldName]['height'] : settings.product_image_height
    };
  },
  methods: {
    openFileInput() {
        this.$refs['input_file_'+this.dataFieldName].click()
    },
    deleteImage(image) {
      axios
        .post("/admin/ajax/images/delete", {
          model_id: this.model_id,
          model: this.model,
          image: image,
          required: this.required,
          column: this.column,
        })
        .catch((error) => {
          this.displayAlert(
            "error",
            "Deletion failed"
          );
        })
        .then((response) => {
          if (response.data.success) {
            this.displayAlert("success", "Image successfully deleted!");
            this.images = response.data.images;
          } else if (response.data.msg) {
            this.displayAlert("error", response.data.msg);
          } else {
            this.displayAlert("error", "Deletion failed");
          }
        });
    },
    sortOrderImages() {
      // send new order ajax
      axios
        .post("/admin/ajax/images/sort", {
            model_id: this.model_id,
            model: this.model,
            images: this.images,
            column: this.column,
        })
        .catch((error) => {
          this.displayAlert(
            "error",
            "Sort order impossible, please try again later or contact us"
          );
        })
        .then((response) => {
          if (response.data.success) {
            this.displayAlert("success", "Images order updated!");
          }
        });
    },
    uploadImage(e) {
    //   var files = this.$refs.file.files
      var files = this.$refs['input_file_'+this.dataFieldName].files
      if (!files.length) return;
    //   for (let index = 0; index < files.length; index++) {
        // var file = files[index]
        // var FileSize = file.size / 1024 / 1024; // in MiB
        // if (FileSize > config.product_image_max_size) {
        //   this.displayAlert(
        //     "error",
        //     "Error, one of the files you try to upload is over "+config.product_image_max_size+"Mb"
        //   );
        //   return
        // }
    //   }

      this.displayAlert("info", "Uploading file...");
      // send file ajax
      var formData = new FormData();
      for (var i = 0; i < files.length; i++) {
        let file = files[i];
        formData.append("images[" + i + "]", file);
      }
      formData.append("model_id", this.model_id);
      formData.append("model", this.model);
      formData.append("width", this.width);
      formData.append("height", this.height);
      formData.append("max_images", this.max_images);
      formData.append("column", this.column);
      axios
        .post("/admin/ajax/images/upload", formData)
        .catch((error) => {
          this.displayAlert(
            "error",
            "Upload failed"
          );
        })
        .then((response) => {
          if (response.data.success) {
            this.displayAlert("success", "New images added!");
            this.images = response.data.images;
          } else if (!response.data.success) {
            this.displayAlert("error", response.data.msg);
          }
          // reset input file field
            this.$refs['input_file_'+this.dataFieldName].value = ''
        });
    },
  },
  mounted() {},
  components: {
    draggable,
  },
};
</script>
